import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/nominas/configuraciones-de-reportes-exportables/';

/**
 * GET Configuraciones De Reportes Exportables (del usuario logueado)
 * @param {string} reporteKey
 * @returns {Promise<object[]>}
 */
export const getConfiguracionesDeReportesExportables = async (reporteKey) => {
  try {
    const response = await API.get(baseURI, { params: { reporte_key: reporteKey } });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Configuracion De Reporte Exportable
 * @param {object} values - { reporte_key, nombre, columnas }
 * @returns {Promise<object|boolean>}
 */
export const postConfiguracionDeReporteExportable = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Configuración guardada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Configuracion De Reporte Exportable
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteConfiguracionDeReporteExportable = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Configuración eliminada correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
